// ** React
import { useEffect, useState } from "react";

// ** API
import articlesApi from "../api/articles/api";

export const useSearch = (searchTerm) => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(async () => {
      if (searchTerm.trim().length < 1) {
        setResults({});
        return;
      }

      const data = await articlesApi.searchArticles(searchTerm);
      setResults(data);
      setLoading(false);
    }, 300); // Debounce

    return () => clearTimeout(timeout);
  }, [searchTerm]);

  return { results, loading };
};
